import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppService } from 'src/app/shared/services/app.service';

@Injectable({
  providedIn: 'root'
})
export class MunicipalitiesService {

  constructor(private appService: AppService,
    private http: HttpClient,) { }

  private municipalities: any[] = [];

  getAllMunicipalities() {
    const reqheaders = new HttpHeaders().set('token', this.appService.loggedUser.uuid);

    return this.http.get<any[]>(`${this.appService.config.API}/admin/ministry/get_all_cities`, { headers: reqheaders })
      .pipe(
        tap(data => {
          this.municipalities = data;
        }),
        catchError(error => {
          console.error('Error fetching municipalities:', error);
          return of([]); // Return an empty array on error
        })
      );
  }


  getMunicipalities(): any[] {
    return this.municipalities.slice();
  }

  getMunicipalityById(id: string) {
    const reqheaders = new HttpHeaders().set('token', this.appService.loggedUser.uuid);
    console.log("id______________");
    console.log(id);


    return this.http.get<any[]>(`${this.appService.config.API}/admin/ministry/city/${id}`, { headers: reqheaders })
  }

  // getMunicipalityById(id: string) {
  //   console.log("this.municipalities_________");
  //   console.log(this.municipalities);


  //   return this.municipalities.slice().find(municipality => {


  //     console.log("this.municipalities_________________________111111111111111111111111111111111111111111111111111111111111111");
  //     console.log(this.municipalities);


  //     if (municipality.account[0]._id === id) {
  //       console.log("Found municipality:", municipality);
  //       return true;
  //     }
  //     return false;
  //   });
  // }

  // getAccountById(id: string) {
  //   return this.municipalities.account.find(account => account._id === id) || null;
  // }
}
